import React from 'react';
import { useDispatch } from 'react-redux';
import { Button, CircularProgress, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';

import { closeDialog, openDialog } from 'app/store/fuse/dialogSlice';
import { GridList, usePagination, useSettings, Utils } from 'app/main/components';
import { ViewPagination } from 'app/main/components/page-layouts';
import DemsMessagesMailupListItem from './DemsMessagesMailupListItem';

interface DemsSendToMailupDialogDialogProps {
	demsUid: string;
	onSuccess: VoidFunction;
}

export function showSendDemToMailupDialog(props: DemsSendToMailupDialogDialogProps) {
	return openDialog({
		children: <DemsSendToMailupDialog {...props} />,
		fullWidth: true
	});
}

export default function DemsSendToMailupDialog({ demsUid, onSuccess }: DemsSendToMailupDialogDialogProps) {
	const dispatch = useDispatch();
	const { settings, t } = useSettings('dems');

	const [mailMessages, setMailMessages] = React.useState([]);

	const [refresh, setRefresh] = React.useState(true);
	const updateRefresh = () => setRefresh(value => !value);

	const paginationProps = usePagination({ module: 'dems' });

	const {
		paginatorProps: { nPage, nRows, setMaxRows, isLoading, setIsLoading }
	} = paginationProps;

	React.useEffect(() => {
		setIsLoading(true);
		Utils.executeApi.get({
			url: `/api/mailup/messages?pageNumber=${nPage - 1}&rowCount=${nRows}`,
			dispatch,
			successHandler: response => {
				setMailMessages(response.data.Items);
				setMaxRows(response.data.TotalElementsCount);
				setIsLoading(false);
			}
		});
	}, [dispatch, nPage, nRows, refresh, setIsLoading, setMaxRows]);

	if (!isLoading)
		return (
			<>
				<DialogTitle>{t('DEMS_MESSAGES_DIALOG_TITLE')}</DialogTitle>
				<DialogContent className="flex flex-col p-0" dividers>
					{mailMessages?.length > 0 ? (
						<>
							<GridList
								className="overflow-y-auto"
								settings={settings}
								idField="idMessage"
								items={mailMessages}
								itemLayout={layoutProps => (
									<DemsMessagesMailupListItem
										{...layoutProps}
										demsUid={demsUid}
										handleNext={onSuccess}
									/>
								)}
								updateRefresh={updateRefresh}
							/>
							<ViewPagination
								module="dems"
								paginationProps={paginationProps}
								updateRefresh={updateRefresh}
								showFilters={false}
								showOrder={false}
								showBorderTop
							/>
						</>
					) : (
						<Typography>No templates</Typography>
					)}
				</DialogContent>
				<DialogActions>
					<Button onClick={() => dispatch(closeDialog())}>{t('DIALOG_ACTION_CANCEL')}</Button>
				</DialogActions>
			</>
		);

	return (
		<>
			<DialogTitle>{t('DEMS_MESSAGES_DIALOG_TITLE')}</DialogTitle>
			<DialogContent>
				<CircularProgress disableShrink />
			</DialogContent>
		</>
	);
}
